import { SubscriptionStatisticsType } from "../../../types/Student";
import { get } from "../../../utils/axios-config";
import { SUBSCRIPTION_STATISTICS_BY_COURSE } from "../../../utils/constants";

export const getSubscriptionStatisticsByCourse = async (data: any) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || "1",
        PageSize: data?.PageSize?.toString() || "100",
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear  } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse  } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject  } : {}),
         ...(data?.Semester ? { Semester: `${data.Semester}`  } : {}),
         ...(data?.Level ? { Level: `${data.Level}`  } : {}),
         ...(data?.Regime ? { Regime: `${data.Regime}`  } : {}),
    });
    return await get<SubscriptionStatisticsType[]>(`${SUBSCRIPTION_STATISTICS_BY_COURSE}?${queryParams.toString()}`);
};

